module.exports = __webpack_public_path__ + "static/media/ios-umbrella.0003d710.svg";